module.exports = __webpack_public_path__ + "build.png?61574e86308f69fcccfd334a19cfb236";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/build.png
// module id = 342
// module chunks = 0